var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 73,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M48.573 9.666 28.05 3.392a5.8 5.8 0 0 0-7.243 3.85L7.242 51.616a5.8 5.8 0 0 0 3.851 7.242l33.28 10.174a5.8 5.8 0 0 0 7.242-3.85l6.274-20.522M13.566 11.092l11.093 3.392m-14.484 7.701 11.093 3.392M6.783 33.279l11.093 3.392M3.392 44.373l11.093 3.39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M67.624 26.487a6.16 6.16 0 1 0-5.784-10.878L43.697 25.26a5.8 5.8 0 0 0-2.128 1.94l-4.754 7.25a1.45 1.45 0 0 0 1.194 2.244l8.669.113a5.8 5.8 0 0 0 2.797-.68z"
  })));
};
export default SvgNote;